import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QuestionnaireSummary } from '../models/questionnaireSummary.model';
import { InclusionIndexDashboard } from '../models/inclusionIndexDashboard';
import { environment } from '../environments/environment';
import { QuestionnaireStatusDto } from '../models/questionnaireStatus.model';

export interface QuestionnaireAvailability {
  canFill: boolean;
  reason: string;
  reasonParams?: Record<string, string>;
}

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  constructor(private http: HttpClient){}

  getTraineeQuestionnaires(): Observable<QuestionnaireSummary[]> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.http.get<QuestionnaireSummary[]>(environment.apiUrl + '/api/questionnaires/company',{headers});
  }

  getSelfAssesments(): Observable<QuestionnaireSummary[]> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.http.get<QuestionnaireSummary[]>(environment.apiUrl + '/api/questionnaires/company/self-questionnaires',{headers});
  }

  isCompanyQuestionnaireFilled(): Observable<boolean> {
      const token = localStorage.getItem('token');

      const headers = {
        Authorization: `Bearer ${token}`
      };
    return this.http.get<boolean>(environment.apiUrl + '/api/questionnaires/company/isFilled', {headers});
  }

  getStatusByUser(traineeId: number): Observable<QuestionnaireStatusDto> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.http.get<QuestionnaireStatusDto>(`${environment.apiUrl}/api/questionnaires/trainee/${traineeId}/status`,{ headers });
  }

  canFillQuestionnaire(): Observable<QuestionnaireAvailability> {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
  return this.http.get<QuestionnaireAvailability>(`${environment.apiUrl}/api/questionnaires/can-fill-questionnaire`,{headers});
  }

  getLast3TraineeQuestionnaires() {
    const token = localStorage.getItem('token') || '';
    const headers = { Authorization: `Bearer ${token}` };

    return this.http.get<any[]>(`${environment.apiUrl}/api/questionnaires/last3-trainee`, { headers });
  }


}
